/**
 * 하단바 「카탈로그」 탭 동작
 * - REACT_APP_CATALOG_TAB_TOBE=true  → /digital-catalog 페이지 이동
 * - REACT_APP_CATALOG_TAB_TOBE=false → PDF 직접 다운로드 (기존)
 */
export const catalogTabTobe =
  (process.env.REACT_APP_CATALOG_TAB_TOBE || 'true') === 'true'

export function openLegacyCatalogDownload() {
  const base = process.env.REACT_APP_BASE_API || ''
  window.open(`${base}/api/cadalog/download`, '_blank')
}

export function handleCatalogTabClick(navigate, pathname) {
  if (catalogTabTobe) {
    if (pathname === '/digital-catalog') return
    navigate('/digital-catalog')
    return
  }
  openLegacyCatalogDownload()
}
